export enum BulkActionProcessingStatus {
    READY = "READY",
    PROCESSING = "PROCESSING",
    WARNING = "WARNING",
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
}

export interface IBulkActionPayload {
    id: string;
    brandId: string;
    name: string;
    route?: string;
    method?: string;
    data?: string;
    status: BulkActionProcessingStatus;
    error?: string;
    resultCustomizer?: (response: any) => any;
}
